import WrapperComponent from '../components/hoc/Wrapper-component';
import { ClaimAdd } from './claim/claim-add/ClaimAdd';
import { ClaimEdit } from './claim/claim-edit/ClaimEdit';
import { ClaimList } from './claim/claim-list/ClaimList';
import { ClaimView } from './claim/claim-view/ClaimView';
import { UserPermission } from './permission/UserPermission';
import { ProductWarranty } from './product-warranty/ProductWarranty';
import { RegistrationAdd } from './registration/registration-add/RegistrationAdd';
import { RegistrationEdit } from './registration/registration-edit/RegistrationEdit';
import { RegistrationList } from './registration/registration-list/RegistrationList';
import { RegistrationView } from './registration/registration-view/RegistrationView';
import { ReportClaim } from './report-claim/ReportClaim';
import { ReportWarranty } from './report-warranty/ReportWarranty';
import { ReportPage } from './report/ReportPage';
import { ScanDelivery } from './scan-delivery/ScanDelivery';
import { UserInfo } from './user-info/UserInfo';
import { MainPage } from './welcome';
import { GenQrCode } from './gen-qr/GenQrCode';
import { ColorQr } from './color-qr/ColorQr';

export default {
  RegistrationList: WrapperComponent('RegistrationList')(RegistrationList),
  RegistrationAdd: WrapperComponent('RegistrationAdd')(RegistrationAdd),
  RegistrationView: WrapperComponent('RegistrationView')(RegistrationView),
  RegistrationEdit: WrapperComponent('RegistrationView')(RegistrationEdit),
  ClaimList: WrapperComponent('ClaimList')(ClaimList),
  ClaimAdd: WrapperComponent('ClaimAdd')(ClaimAdd),
  ClaimEdit: WrapperComponent('ClaimEdit')(ClaimEdit),
  ClaimView: WrapperComponent('ClaimView')(ClaimView),
  ScanDelivery: WrapperComponent('ScanDelivery')(ScanDelivery),
  ProductWarranty: WrapperComponent('ProductWarranty')(ProductWarranty),
  ReportPage: WrapperComponent('ReportPage')(ReportPage),
  ReportWarranty: WrapperComponent('ReportWarranty')(ReportWarranty),
  ReportClaim: WrapperComponent('ReportClaim')(ReportClaim),
  UserPermission: WrapperComponent('UserPermission')(UserPermission),
  UserInfo: WrapperComponent('UserInfo')(UserInfo),
  MainPage: WrapperComponent('MainPage')(MainPage),
  GenQrCode: WrapperComponent('GenQrCode')(GenQrCode),
  ColorQr: WrapperComponent('ColorQr')(ColorQr),
};
